<div class="uk-padding-small">
  @switch (fbService.sideMenuSettingsType()) {
    @case ('main') {
      <app-main-settings></app-main-settings>
    }
    @case ('chapter') {
      <app-chapter-settings></app-chapter-settings>
    }
    @case ('section') {
      <app-section-settings></app-section-settings>
    }
    @case ('field') {
      <app-field-settings></app-field-settings>
    }
    @case ('fieldSelector') {
      <app-field-type-selections></app-field-type-selections>
    }
  }
</div>
